import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconFacilities = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 103.99314 91.807762">
    <g fill={theme.palette.grey[100]}>
      <polygon points="31.337 92.004 39.352 38.44 21.499 35.203 0 81.078" />
      <polygon points="31.337 92.004 64.439 81.02 58.189 35.203 39.352 38.44" />
      <polygon points="103.99 92.004 77.98 38.44 58.189 35.203 64.439 81.02" />
    </g>
    <polygon fill={theme.palette.primary.A100} points="58.941 40.782 63.339 73.071 88.715 79.864 72.512 43.268" />
    <polygon fill={theme.palette.primary.A100} points="8.5359 76.308 32.349 83.679 38.426 44.019 24.45 41.504" />
    <polygon fill={theme.palette.primary.A400} points="38.426 44.019 32.349 83.679 63.339 73.071 58.941 40.782" />
    <g transform="translate(26.999 .06241)">
      <path fill={theme.palette.primary.A100} d="m47.191 23.693c0 13.008-23.582 41.423-23.582 41.423s-23.582-28.415-23.582-41.423 10.561-23.559 23.582-23.559 23.582 10.522 23.582 23.559" />
      <path fill={theme.palette.primary.A400} d="m23.58 9.8181c6.5999 0 11.95 5.345 11.95 11.938 0 6.5934-5.3503 11.938-11.95 11.938-6.5999 0-11.95-5.345-11.95-11.938 0-6.5934 5.3503-11.938 11.95-11.938" />
    </g>
  </SvgIcon>
);

IconFacilities.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconFacilities);



// WEBPACK FOOTER //
// ./src/components/icons/IconFacilities.js